window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');
      
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    if(!$('.edit-address-form').hasClass('hide')){
        $('.edit-address-form').addClass('hide');
    }
    if(!$('.js-noEdit').hasClass('hide')){
       $('.js-noEdit').addClass('hide');
    } else {
        $('.js-noEdit').removeClass('hide');
    }
    
    $newAddressForm.toggleClass('hide');
    
    if($(this).hasClass('js-isCancel')){
      $('html, body').animate({
          scrollTop: 0
        }, 1000);
    }
});

$('.address-edit-toggle').on('click', function() {
    if(!$newAddressForm.hasClass('hide')){
        $newAddressForm.addClass('hide');
    }
    if(!$('.js-noEdit').hasClass('hide')){
       $('.js-noEdit').addClass('hide');
    } else {
        $('.js-noEdit').removeClass('hide');
    }
    
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
    
    if($(this).hasClass('js-isCancel')){
      $('html, body').animate({
          scrollTop: 0
        }, 1000);
    }
});

$('.address-delete').on('click', function() {
  var $el = $(this);
  var formId = $el.data('form-id');
  var confirmMessage = $el.data('confirm-message');
  if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
    Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
  }
});
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


site = {
    browserWidth: 0,
    setBrowserWidth : function() {
        site.browserWidth = window.innerWidth || document.documentElement.clientWidth;
    },
    initAppendAround : function(){
        $('.js-appendAroundContent').appendAround();
    },
    initNavigation : function(){
        // NAVIGATION //

        $nav = $(".js-nav");
        $navToggle = $(".js-navToggleBtn"); // this opens the nav < xlarge
        $subNavButton = $(".js-subnavToggleBtn"); // this is for touching
        $subNavToggle = $subNavButton.parent('li'); // this is for hovering
        $subNavBgToggle = $subNavButton.parent('.js-hasDropdown'); // this is for hovering
        $subNavBgToggle2 = $('.site-nav'); // this is for hovering
        $buttonLink = $(".js-link"); // When a button is clickable as link
        
        $navToggle.on("click", toggleNav);
        $subNavButton.on("click", openSubNav);
        $subNavToggle.hoverIntent({over:dropDown, timeout: 200});
        $subNavBgToggle2.hoverIntent({over:dropBg, timeout: 200});
        $buttonLink.on("click", buttonLink);
        
        function dropDown(){
            if (site.browserWidth >= 960){
                $(this)
                    .children("button")
                    .first()
                    .toggleClass('is-open')
                    .next("ul")
                    .toggleClass('is-open');
            }
        }
        
        function dropBg(){
            if (site.browserWidth >= 960){
                $(this)
                    .toggleClass('is-open');
            }
        }
        
        function openSubNav(event) {
            event.preventDefault();
            
            function Drop(){
                $(this)
                    .children("button")
                    .first()
                    .toggleClass('is-open')
                    .next("ul")
                    .toggleClass('is-open');
            }
            
            if (site.browserWidth < 960 && event.type == "click") {
                $(this)
                    .toggleClass('is-open')
                    .next("ul")
                    .slideToggle()
                    .toggleClass('is-open');
            } else if (site.browserWidth >= 960 && (event.type == "mouseenter" || event.type == "mouseleave")) {
                // You are large, and you hovered
                // Not using this now, instead using hover intent and dropDown
                    
            } else {
                // Die for all other events
                return false;
            }
        }
        
        function toggleNav(event) {
            event.preventDefault();
               
            $nav.toggleClass('active');
            $('body').toggleClass('nav-active');
            $navToggle.toggleClass('is-active');
        }
        
        function buttonLink(event) {
            event.preventDefault();
            
            if (site.browserWidth >= 960) {
                window.location = $(this).data('href');
            }
        }

    },
    initToggleContent : function()
    {
        $('.js-toggleBtn').on('click',function(e){
            $(this).next('.js-toggleContent').slideToggle();
            $(this).toggleClass('is-open');
        });
        if(window.location.hash) {
            var url = window.location.href;
            var hash = url.substring(url.indexOf('#'));
            
            $('html, body').animate({
              scrollTop: $(hash).offset().top - 100
            }, 500);
            
            $(hash).next('.js-toggleContent').slideToggle();
            $(hash).toggleClass('is-open');
        }
    },
    initTabs : function()
    {
        $('.js-tab').on('click',function(){
            var id = $(this).attr('data-tab');
            $('.js-tab, .js-tabContent').removeClass('active');
            $(this).addClass('active');
            $('#'+id).addClass('active');
        });
    },
    initReadMore : function()
    {
        $('.js-readMoreBtn').on('click',function(e){
            e.preventDefault();
            
            var openText = '+ read more';
            var closeText = '- read less';
            if($(this).hasClass('is-open')){
                $(this).removeClass('is-open').html('<span>'+ openText + '</span>').parent().find('.js-readMoreContent').removeClass('open');
            }
            else{
                $(this).addClass('is-open').html('<span>' + closeText + '</span>').parent().find('.js-readMoreContent').addClass('open');
            }
        });
        
        $('.js-readMoreContent').on('click',function(){
            //alert('clicked');

            var openText = '+ read more';
            var closeText = '- read less';
            var btn = $(this).next('.js-readMoreBtn');
            if(!$(this).hasClass('open')){
                $(btn).addClass('is-open').html('<span>' + closeText + '</span>');
                $(this).addClass('open');
            }
            
        });
        
    },
    initFormValidate : function()
    {
        $('.js-newsletterFormContainer form').validate({
            rules: {
                "contact[email]": {
                    required:true,
                    email: true
                }
            },
            messages: {
                "contact[email]": {
                    required:"Please enter your email address.",
                    email: "Please enter a valid email address."
                }
            }
        });
        $('.js-contactForm form#contact_form').validate({
            rules: {
              "contact[name]": {
                required:true
              },
              "contact[email]": {
                required:true,
                email: true
              },
              "contact[body]": {
                required:true
              }
            },
            messages: {
              "contact[name]": {
                required:"Please enter your name."
              },
              "contact[email]": {
                required:"Please enter your email address.",
                email: "Please enter a valid email address."
              },
              "contact[body]": {
                required:"Please provide a brief message."
              }
            }
        });
    },
    initLazyLoad : function()
    {
        const observer = lozad('.lozad', {
            rootMargin: '350px 0px' // syntax similar to that of CSS Margin
        });

        observer.observe();
    },
    initAnimate : function()
    {
        AOS.init({
            // Global settings
            disable: 'mobile'
        });
    },
    initSelectSize : function()
    {
        if(site.shouldRun('template-collection')){
            if (site.browserWidth < 1025){
            $(window).on('load',function(){
                var $this = $('#sort-by');
                // create test element
                var text = $this.find('option:selected').text();
                var $test = $('<span>').html(text);
                
                // add to body, get width, and get out
                $test.appendTo('body');
                var width = $test.width();
                $test.remove();
                
                // set select width
                $this.width(width);
            });
            $(window).on('resize',function(){
                var $this = $('#sort-by');
                // create test element
                var text = $this.find('option:selected').text();
                var $test = $('<span>').html(text);
                
                // add to body, get width, and get out
                $test.appendTo('body');
                var width = $test.width();
                $test.remove();
                
                // set select width
                $this.width(width);
            });
            }
        }
    },
    initQuickCart: function(){
      //open and closes sidecart
      $('.header__cart-btn').on('click', function(e){
          e.preventDefault();
          $('body').addClass('sidecart-open');
      });
    
      $('.sidecart-close, .sidecart-overlay, #close-sidecart').on('click', function(){
          $('body').removeClass('sidecart-open');
      });
      
      // Listens for Cart Event and Updates Cart Counters
      $(document).on('cart.requestComplete', function(event, cart) {
            $('.header__cart-btn span').html(cart.item_count);
            if( cart.item_count == 0 ){
              $('#incart_upsell').css('display','none');
            }else{
              var cart_products_id = $.map(cart.items, function(item){ return item.product_id});
              var upsell_product_id = parseInt($('#incart_upsell').attr('data-gift-id')) || 0;
              if( $.inArray( upsell_product_id, cart_products_id) == -1 ){
                  $('#incart_upsell').css('display','block');
                  var threshold = parseInt($('#incart_upsell').attr('data-threshold')) || 0;
                  var cart_total = Shopify.formatMoney(cart.original_total_price);
                  cart_total = cart_total.replace('$','');
                  var left_value = threshold - cart_total;
                  if (left_value < 0) {
                      left_value == 0;
                  }
                  left_value = left_value.toFixed(2);
                  //console.log(left_value);
                  $('.left_value_free_gift').text('$' + left_value);
                  if (cart_total < threshold) {
                      $('.lessthan-threshold').removeClass('visually-hidden');
                      $('.reach-threshold').addClass('visually-hidden');
                  }else{
                      $('.lessthan-threshold').addClass('visually-hidden');
                      $('.reach-threshold').removeClass('visually-hidden');
                  }
              }else{
                  $('#incart_upsell').css('display','none');
              }


              injectUpsell();
              remainingAmountFreeGift();
              $('#incart_upsell').css('display','block');

            }

            $.each(cart.items, function(i, item){
                  if( parseInt(item.properties.subscription_id) > 0 ){
                      $('#sidecart .sidecart__checkout').removeAttr('data-disable-recharge');
                      return false;
                  }else{
                      $('#sidecart .sidecart__checkout').attr('data-disable-recharge','');
                  }
            });

            $('body').addClass('sidecart-open');

          freeGiftCheck(cart);
      });

      $(document).on('cart.requestStarted', function(event, cart) {
          if( !$('body').hasClass('sidecart-open') ){
              $('.sidecart-contents tr td:first img').attr('src','');
          }
      });

      $(document).on('click','#nudge-offer form[action="/cart/add"] button[name="add"]',function(e){
          e.preventDefault();
          var $form = $(this).closest('form[action="/cart/add"]');
          var p_id = $('[name="id"]', $form).val() || 0;
          var quantiry = $('[name="quantity"]', $form).val() || 1;
          if( p_id > 0){
              CartJS.addItem(p_id, quantiry);
          }
      });

      function freeGiftCheck(cart){
          var motivatorHost = 'https://motivate.boldapps.net';
          var promise = $.ajax({
              url: motivatorHost + '/cf_helper/get_country.php',
              dataType: 'json'
          });

          promise.done(function(data) {
              shappify_motivator_country = data;
              var payload = {
                  shop: myshopify_domain,
                  country: shappify_motivator_country
              };

              var premium_goals = $.ajax({
                  url: motivatorHost + '/get_premium_goals.php',
                  dataType: 'json',
                  data: payload
              });

              premium_goals.done(function(goals) {
                  shappify_motivator_goals = goals;
                  is_premium = false;
                  custom_trigger_messages(cart);
              });
          });
      }

      function custom_trigger_messages(data) {
          var messages = Array();
          var tmp = new Date().getTime();
          var motivator_last_total = getCookie("motivator_last_total");
          var mcart = null;
          mcart = data;
          var cart_variant_id = $.map(mcart.items, function(item){ return item.variant_id});
          if(typeof window.BOLD !== 'undefined'
              && typeof window.BOLD.common !== 'undefined'
              && typeof window.BOLD.common.cartDoctor !== 'undefined') {
              mcart = window.BOLD.common.cartDoctor.fix(mcart);
          }

          if(mcart && shappify_motivator_goals){
              for (shappify_i = 0; shappify_i < shappify_motivator_goals.length; shappify_i++) {
                  var motivator_was_initialised = getCookie("motivator_initialised_" + shappify_motivator_goals[shappify_i].id);
                  var motivator_was_confirmed = getCookie("motivator_confirmed_" + shappify_motivator_goals[shappify_i].id);
                  var variant_id = parseInt(shappify_motivator_goals[shappify_i].variant_id);

                  if (!motivator_was_initialised) {
                      messages.push("<span class='shapp_pitch' data-country='"+shappify_motivator_country+"'>"+shappify_motivator_goals[shappify_i].pitch+"</span>");
                  }else if(mcart.total_price != motivator_last_total){
                      var free_product_enabled = shappify_motivator_goals[shappify_i].free_product_enabled;
                      //var variant_id = shappify_motivator_goals[shappify_i].variant_id;
                      if( $.inArray( variant_id, cart_variant_id) == -1 ){
                          motivator_was_confirmed = "0";
                      }

                      var bal = (100 * shappify_motivator_goals[shappify_i].goal) - (mcart.total_price);
                      if(bal>0){
                          messages.push(shappify_motivator_goals[shappify_i].pre_balance +" <span class='shappify-motivator-bal'>" +formatMoney(bal, "${{amount}}") + "</span> " + shappify_motivator_goals[shappify_i].post_balance );
                          setCookie("motivator_confirmed_" + shappify_motivator_goals[shappify_i].id, 0, 1);

                          $.each(mcart.items, function(i, v) {
                              if (v.variant_id == variant_id) {
                                  ShappjQuery.post('/cart/update.js', "updates[" + variant_id + "]=0").always(function(data) {
                                      CartJS.getCart({
                                          "success": function(data, textStatus, jqXHR) {
                                              //$('[data-variant-id="'+ variant_id +'"]').closest('tr').find('[rv-data-cart-update]').show();
                                              //$('[data-variant-id="'+ variant_id +'"]').closest('tr').find('.remove-item-icon').show();
                                          }
                                      });
                                  });
                              }
                          });

                      }else if(motivator_was_confirmed == "0" || motivator_was_confirmed == null ){
                          if (free_product_enabled && variant_id) {
                              ShappjQuery.post('/cart/add.js', { quantity: 1, id: variant_id })
                              .always(function(data) {
                                  CartJS.getCart({
                                      "success": function(data, textStatus, jqXHR) {
                                          //$('[data-variant-id="'+ variant_id +'"]').closest('tr').find('[rv-data-cart-update]').show();
                                          //$('[data-variant-id="'+ variant_id +'"]').closest('tr').find('.remove-item-icon').show();
                                      }
                                  });
                              });
                          }

                          messages.push("<span class='shapp_confirmation'>"+shappify_motivator_goals[shappify_i].confirmation+"</span>");
                          setCookie("motivator_confirmed_" + shappify_motivator_goals[shappify_i].id, 1, 1);
                      }
                      
                  }
                  setCookie("motivator_initialised_" + shappify_motivator_goals[shappify_i].id, 1, 1);
                  setCookie("motivator_last_total", mcart.total_price, 1);
              }
              show_messages(messages);
          }
      }

      injectUpsell();
      function injectUpsell(){
          var count = 0;
          var timeout = setInterval(function() {
              count++;
              if($('#nudge-offer form[action="/cart/add"]').length > 0) {
                  $('#nudge-offer form[action="/cart/add"]').each(function(){
                      if ( !$('#nudge-offer .offer-collection').length ) {
                          $('#nudge-offer').wrapInner('<div class="offer-collection"></div>');
                          $('#nudge-offer .offer-text').insertBefore($('#nudge-offer .offer-collection'));
                      }

                      remainingAmountFreeGift();
                      var text = $('#nudge-offer .product-title-wrapper').html();
                      text = text.replace(/:/ig,'');
                      $('#nudge-offer .product-title-wrapper').html(text);
                      var variant_selected = $('[name="id"] option:selected',this).text() || '';
                      if ( (variant_selected.indexOf('Default Title') == -1) && (variant_selected != '') && (!$('#nudge-offer .cart__item-variant').length) ) {
                          $('#nudge-offer .product-title').after('<span class="cart__item-variant">'+ variant_selected +'</span>');
                      }
                      //console.log(my_offers);
                      //$('button[name="add"]', this).attr('onclick','');
                      //InCartUpsell.acceptShopifyOffer(55116, 'a', this.form); return false;
                      if (typeof my_offers == 'object') {
                          var offer_id = $('#nudge-offer').attr('data-offerid');
                          var product_id = 0;
                          $.each(my_offers, function(key, offer){
                              //console.log(offer);
                              if (offer.id == offer_id) {
                                  //product_id = offer.rules[0].itemShopifyId;
                                  product_id = offer.offerable_product_shopify_ids[0];
                                  //console.log(product_id);
                                  return;
                              }
                          });
                          if( product_id > 0 && !$('#nudge-offer .stamped-product-reviews-badge').length ){
                              if ( $('#nudge-offer .product-price-wrapper').length ) {
                                  $('#nudge-offer .product-price-wrapper').before('<span class="stamped-product-reviews-badge stamped-main-badge" data-id="'+ product_id +'" style="display: inline-block;"></span> ');
                              }else{
                                  $('#nudge-offer .product-title-wrapper').append('<span class="stamped-product-reviews-badge stamped-main-badge" data-id="'+ product_id +'" style="display: inline-block;"></span> ');
                              }
                              StampedFn.loadBadges();
                              
                          }
                      }

                  });
                  clearInterval(timeout);
                  return;
              }else{
                  if( count > 25 ){
                      clearInterval(timeout);
                      return;
                  }
              }
          }, 250);
      }
      function remainingAmountFreeGift(){
          if ( $('#nudge-offer .offer-text').length ) {
              var text = $('#nudge-offer .offer-text').html();
              var remaining_amount = $('#sidecart [data-cart-render="total_price_money"]').text();
              remaining_amount = parseFloat(remaining_amount.replace('$',''));
              remaining_amount = (75 - remaining_amount);
              if( remaining_amount < 0 ){
                  remaining_amount = 0;
              }
              remaining_amount = remaining_amount.toFixed(2);
              text = text.replace(/{dynamic_amount}/ig, '<span class="price"></span>');
              $('#nudge-offer .offer-text').html(text);
              $('#nudge-offer .offer-text').find('.price').html('$' + remaining_amount);
          }
      }
      
  },
    initSubNavStick : function()
    {
        if (site.browserWidth >= 1025){
            var $headerHeight = $('.js-header').height();
            var $navHeight = $('.js-subNav').height();
            var $stickPoint = $headerHeight;
            
            
            if($(window).scrollTop()<$stickPoint) {
              $('body').removeClass('navStick');
            } else {
              $('body').addClass('navStick');
            }
        }
    },
    initSectionToScroll : function()
    {
        function sitesSlick(){
            $window = $(window);
            $slick_slider = $('.js-mobileSlider');
            settings = {
              slidesToShow: 1,
              slidesToScroll: 1,
              appendArrows: $(".js-mobileSliderNav"),
              prevArrow: '<button type="button" class="slick-prev btn btn--primary"><span>Prev</span></button>',
              nextArrow: '<button type="button" class="slick-next btn btn--primary"><span>Next</span></button>',
            };
            
            if ($window.width() <= 768) {
                $slick_slider.slick(settings);
            }
            $window.on('resize', function() {
              if ($window.width() > 768) {
                if ($slick_slider.hasClass('slick-initialized'))
                  $slick_slider.slick('unslick');
                return
              }
              if ( ! $slick_slider.hasClass('slick-initialized'))
                return $slick_slider.slick(settings);
            });  
        }
        if(site.shouldRun('template-index')){
            sitesSlick();
        }
        if(site.shouldRun('template-article')){
            sitesSlick();
        }
    },
    initQuantityIncrement : function ()
    {
        if(site.shouldRun('template-cart')){
            $(".js-increment").on("click", function(e) {
                e.preventDefault();
                var $button = $(this);
                var oldValue = $button.parent().find("input").val();
                
                if ($button.text() == "+") {
                    var newVal = parseFloat(oldValue) + 1;
                  } else {
                 // Don't allow decrementing below zero
                  if (oldValue > 0) {
                    var newVal = parseFloat(oldValue) - 1;
                  } else {
                    newVal = 0;
                  }
                }
                
                $button.parent().find("input").val(newVal);
            
            });
            
            $(".stepperInput__input").on("change paste keyup", function() {
                var newVal = $(this).parent().find("input").val();
                $(this).closest('.js-productBuyContainer').find('.js-quantityValue').html(newVal);; 
            });
        }
    },
    initListToSelect : function()
    {
        $selectNav = $(".js-selectNav");

        // Create the dropdown base
        $("<select class='page-nav__select js-page-nav-select' />").appendTo($selectNav);
        // Create the dropdown base

        // Populate dropdown with menu items
        $($selectNav).find("a").each(function() {
            var $item = $(this),
                $selected = $item.hasClass('current');
            $("<option />", {
                "value"     : $item.attr("href"),
                "text"      : $item.text(),
                "selected": $selected
            }).appendTo(".js-page-nav-select");
            
        });  
        
        $selectNav.on("change",function() {
            $selectedNav = $(".js-page-nav-select option:selected");
        
            if ($selectedNav!=='') {
              window.location.href=$selectedNav.val();
            }
        });
    },
    shouldRun : function (className)
	{
		return document.body.classList.contains(className);
	},
    
    run : function()
	{
      site.setBrowserWidth();
      site.initNavigation();
      site.initAppendAround();
      site.initToggleContent();
      site.initFormValidate();
      site.initLazyLoad();
      site.initTabs();
      site.initReadMore();
      site.initSelectSize();
      site.initSubNavStick();
      site.initSectionToScroll();
      site.initQuantityIncrement();
      site.initAnimate();
      site.initListToSelect();
      site.initQuickCart();
    },
    resize : function()
	{
    	site.initSelectSize();
    },
	
	helpers : {
		debounce : function (func, wait, immediate) {
			var timeout;
			return function() {
				var context = this, args = arguments;
				var later = function() {
					timeout = null;
					if (!immediate) func.apply(context, args);
				};
				var callNow = immediate && !timeout;
				clearTimeout(timeout);
				timeout = setTimeout(later, wait);
				if (callNow) func.apply(context, args);
			}
		}
	}
}

$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
  var triggerResize = site.helpers.debounce(function() {
        if($(this).width() != site.browserWidth){
        	site.setBrowserWidth();
        }
   }, 250);
   
   site.run(); 
    
   window.addEventListener('resize', triggerResize);
   $(window).scroll(function(evt) {
        site.initSubNavStick();
    });
    
});
